import { GA4Promotion, PromotionData, UAPromotion } from './types';
import { gtagWrapper, getPageLocation } from '../google-analytics/utils';
import { createConfigParametersRepository } from '../../configParametersRepository';
import { checkGaInit } from '../init/ga';
import { CUSTOM_PARAMS_STORAGE_KEY } from '../resources/constants';
import { CustomParams } from '../google-analytics/ga4Types';
import { handlePromotionError } from './error';

export const trackSelectPromotion = (promotion: GA4Promotion) => {
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const { getTrackingStoredValue } = getTrackingStorageClient();
  const storedParams = getTrackingStoredValue(
    CUSTOM_PARAMS_STORAGE_KEY
  ) as CustomParams;
  gtagWrapper('event', 'select_promotion', {
    page_location: getPageLocation(storedParams?.screen_name),
    ...promotion,
  });
};

const parsePromotionToGa4 = (promo: UAPromotion, index: number) => {
  return {
    promotion_id: promo.id,
    promotion_name: promo.name,
    creative_name: promo.creative,
    creative_slot: promo.position,
    items: [
      {
        item_id: promo.id,
        item_name: promo.name,
        index: index,
      },
    ],
  };
};

export const trackGA4Promo = async (data: PromotionData) => {
  handlePromotionError(data);
  await checkGaInit();
  const { promo, isClick, index } = data;
  const ga4Promo: GA4Promotion = parsePromotionToGa4(promo, index);
  if (isClick) {
    trackSelectPromotion(ga4Promo);
  }
};
